// defines position of the vertices
function positionBuffer (dx, dy, dz, graden, gradenAchter) {
  const x = dx / 2
  const y = dy / 2
  const z = dz / 2

  const leftOffset = dy / Math.tan(graden * (Math.PI / 180))
  const rightOffset = dy / Math.tan(gradenAchter * (Math.PI / 180))

  // console.log(x,y,z)
  //return [x, y, z, x, y, -z, x, -y, z, x, -y, -z, -x, y, -z, -x, y, z, -x, -y, -z, -x, -y, z, -x, y, -z, x, y, -z, -x, y, z, x, y, z, -x, -y, z, x, -y, z, -x, -y, -z, x, -y, -z, -x, y, z, x, y, z, -x, -y, z, x, -y, z, x, y, -z, -x, y, -z, x, -y, -z, -x, -y, -z]
  //return [x, -y, z, -x, -y, z, -x, -y, -z,        -x, -y, -z, x, -y, -z, x, -y, z,]
  return [
    x-rightOffset, y, z, 
    x-rightOffset, y, -z, 
    x, -y, z, 
    x, -y, -z, 
    
    -x+leftOffset, y, -z, 
    -x+leftOffset, y, z, 
    -x, -y, -z, 
    -x, -y, z, 
    
    -x+leftOffset, y, -z, 
    x-rightOffset, y, -z, 
    -x+leftOffset, y, z, 
    x-rightOffset, y, z, 

    -x, -y, z, 
    x, -y, z, 
    -x, -y, -z, 
    x, -y, -z, 
    
    -x+leftOffset, y, z, 
    x-rightOffset, y, z, 
    -x, -y, z, 
    x, -y, z, 

    x-rightOffset, y, -z, 
    -x+leftOffset, y, -z, 
    x, -y, -z, 
    -x, -y, -z
  ]
}

// defines position of the textures
function uvBuffer (dx, dy, dz, graden, gradenAchter) { 
  const leftOffset = dy / Math.tan(graden * (Math.PI / 180))
  const rightOffset = dy / Math.tan(gradenAchter * (Math.PI / 180))

  const topLeft = leftOffset/dx
  const topRight = 1-rightOffset/dx

  return [
    topLeft, 1, 
    topRight, 1, 
    topLeft, 0, 
    topRight, 0, 
    
    topLeft, 1, 
    topRight, 1, 
    topLeft, 0, 
    topRight, 0, 
    
    0, 1, 
    1, 1, 
    0, 0, 
    1, 0, 
    
    0, 1, 
    1, 1, 
    0, 0, 
    1, 0, 

    topLeft, 1, 
    topRight, 1, 
    0, 0, 
    1, 0, 
    
    topRight, 1, 
    topLeft, 1, 
    1, 0, 
    0, 0
  ]
}

// defines the shared vertices of position and uv buffer (corners have overlapping vertices which can be refenreced by index instead of defining an new verticie)
function indexBuffer () {
  return [0, 2, 1, 2, 3, 1, 4, 6, 5, 6, 7, 5, 8, 10, 9, 10, 11, 9, 12, 14, 13, 14, 15, 13, 16, 18, 17, 18, 19, 17, 20, 22, 21, 22, 23, 21]
}

// group the vertices belonging to each of the 6 sides, allows for 6 different textures one for each side.
function groupBuffer () {
  return [
    {
      start: 0,
      count: 6,
      materialIndex: 0
    },
    {
      start: 6,
      count: 6,
      materialIndex: 1
    },
    {
      start: 12,
      count: 6,
      materialIndex: 2
    },
    {
      start: 18,
      count: 6,
      materialIndex: 3
    },
    {
      start: 24,
      count: 6,
      materialIndex: 4
    },
    {
      start: 30,
      count: 6,
      materialIndex: 5
    }
  ]
}

export { positionBuffer, uvBuffer, indexBuffer, groupBuffer }